import { pushAppFlyer } from "app/shared/util/app-flyer";
import {
  FETCH_LOGIN_SUCCESS,
  FETCH_USER_INFO_REQUEST,
  FETCH_USER_INFO_SUCCESS,
  FETCH_USER_INFO_FAILURE,
  SET_USER_PROFILE,
  ACTION_LOGOUT,
} from "./actions.type";

import { AuthActions, AuthState } from "./types";

const initialState: AuthState = {
  // check key
  isAuth: false,
  profile: undefined,
  //userinfo
  userProfile: undefined,
  statusUserProfile: "init",
};

const handlerParamsAppFlyer = () => {
  console.log("handlerParamsAppFlyer");
  return {
    eventName: "af_log_out",
    params: {
      af_channel: "ib_rb",
    },
  };
};

export default (state = initialState, action: AuthActions): AuthState => {
  switch (action.type) {
    case FETCH_LOGIN_SUCCESS:
      return {
        ...state,
        isAuth: true,
      };
    // USER INFO
    case FETCH_USER_INFO_REQUEST:
      return {
        ...state,
        statusUserProfile: "pending",
        userProfile: undefined,
      };
    case FETCH_USER_INFO_SUCCESS:
      return {
        ...state,
        userProfile: action.payload,
        statusUserProfile: "ok",
      };
    case FETCH_USER_INFO_FAILURE:
      return {
        ...state,
        statusUserProfile: "error",
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload,
      };
      ;
    // LOGOUT
    case ACTION_LOGOUT:
      const { eventName, params } = handlerParamsAppFlyer();
      pushAppFlyer(eventName, params);
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
